import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useId } from 'react';
import * as jsjoda from '@js-joda/core';
const mappingIn = {
    'text': (x) => x,
    'textarea': (x) => x,
    'email': (x) => x,
    'password': (x) => x,
    'number': (x) => ((x || x === 0) && x.toFixed().toString()) || '',
    'color': (x) => x || undefined,
    'date': (x) => (x && x.format(jsjoda.DateTimeFormatter.ISO_LOCAL_DATE)) || '',
    'time': (x) => (x && x.format(jsjoda.DateTimeFormatter.ISO_LOCAL_TIME)) || '',
    'datetime': (x) => (x && x.format(jsjoda.DateTimeFormatter.ISO_LOCAL_DATE_TIME)) || '',
};
const mappingOut = {
    'text': (x) => x || '',
    'textarea': (x) => x || '',
    'email': (x) => x || '',
    'password': (x) => x || '',
    'color': (x) => x || null,
    'number': (x) => Number(x),
    'date': (x) => (x && jsjoda.LocalDate.parse(x, jsjoda.DateTimeFormatter.ISO_LOCAL_DATE)) || null,
    'time': (x) => (x && jsjoda.LocalTime.parse(x, jsjoda.DateTimeFormatter.ISO_LOCAL_TIME)) || null,
    'datetime': (x) => (x && jsjoda.LocalDateTime.parse(x, jsjoda.DateTimeFormatter.ISO_LOCAL_DATE_TIME)) || null,
};
const TextInput = (props) => {
    const id = useId();
    return _jsx(_Fragment, { children: _jsxs("div", { className: `form-floating ${props.className}`, children: [_jsx("input", { type: {
                        'text': 'text',
                        'email': 'email',
                        'password': 'password',
                        'color': 'color',
                        'number': 'number',
                        'date': 'date',
                        'time': 'time',
                        'datetime': 'datetime-local',
                    }[props.kind || 'text'], id: id, className: `form-control ${{ 'sm': 'form-control-sm', 'md': '', 'lg': 'form-control-lg' }[props.size || 'md']} ${!!props.invalid && 'is-invalid'} ${props.disabled && 'is-disabled'}`, value: mappingIn[props.kind || 'text'](props.value), placeholder: props.label, onChange: (e) => !props.disabled && props.onChange && props.onChange(mappingOut[props.kind || 'text'](e.currentTarget.value)), disabled: !!props.disabled, readOnly: !!props.disabled, "aria-required": props.required || undefined }), _jsxs("label", { className: "form-label", htmlFor: id, children: [props.label, " ", props.required && _jsx("span", { className: "text-danger", "aria-hidden": "true", children: "*" }), " ", props.adornment] }), !props.invalid ? undefined : _jsx(_Fragment, { children: _jsx("div", { className: "invalid-feedback", children: props.invalid }) })] }) });
};
const mapKind = (mapping) => {
    return (props) => mapping[props.kind](props);
};
const Input = (props) => {
    return mapKind({
        'textarea': (props) => _jsx(_Fragment, { children: _jsxs("div", { className: `form-floating`, children: [_jsx("textarea", { className: `form-control ${!!props.invalid && 'is-invalid'} ${props.disabled && 'is-disabled'}`, placeholder: `${props.placeholder || props.label}`, value: props.value, onChange: (e) => !props.disabled && props.onChange && props.onChange(e.currentTarget.value), disabled: !!props.disabled, readOnly: !!props.disabled, "aria-required": props.required || undefined, style: { 'height': '100px' } }), _jsxs("label", { className: "form-label", children: [props.label, props.required && _jsx("span", { className: "text-danger", "aria-hidden": "true", children: "*" }), props.adornment] }), !props.invalid ? undefined : _jsx(_Fragment, { children: _jsx("div", { className: "invalid-feedback", children: props.invalid }) })] }) }),
        'text': TextInput,
        'email': TextInput,
        'password': TextInput,
        'color': TextInput,
        'number': TextInput,
        'date': TextInput,
        'time': TextInput,
        'datetime': TextInput,
    })(props);
};
export default Input;
